export default {
  API: {
    SearchMenu: '/portal/menulist',
    UpdateMenu: '/portal/triggerCallUpdateMenus',
    UpdateUserSchema: '/portal/userSchema',
    conversionApiClientInfo: '/portal/conversionapi/clientinfos',
    getImportJobStatus: '/portal/scheduler/jobs/import-jobs/status',
    generateUploadLink: '/portal/scheduler/jobs/generate-upload-link',
    generateJobFileUploadLink:
      '/portal/scheduler/jobs/generate-job-file-upload-link',
    uploadFilesToIFXAP: '/portal/ifxap/upload-files-to-ifxap',
    schedulerJobExecute: '/portal/scheduler/jobs/execute-job',
    generateDownloadLinkForIFXAPFiles:
      '/portal/scheduler/eventhistories/generate-download-link-for-ifxap-files',
    changeTodayScheduledEvents:
      '/portal/scheduler/events/change-today-scheduled-events',
    startUserDeletionWorkflow: '/portal/start-user-deletion-workflow',
    checkStepFunctionStatus: '/portal/check-step-function-status',
  },
  AUTH: {
    UNAUTH_ID_POOL: 'ap-northeast-1:f11d803d-1b6c-4659-a216-dbf16d48a972',
  },
};
